import React from "react";
import styled from "styled-components";

const PageWrapper = styled.main`
  min-height: 70vh;
  padding: 48px 16px 72px;
  background:
    radial-gradient(circle at 20% 15%, rgba(255, 180, 80, 0.18), transparent 28%),
    linear-gradient(135deg, #171321 0%, #242035 48%, #171321 100%);
  color: #fff;
`;

const Card = styled.section`
  width: min(760px, 100%);
  margin: 0 auto;
  padding: clamp(24px, 5vw, 42px);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.075);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(14px);
`;

const Title = styled.h1`
  margin: 0 0 12px;
  font-size: clamp(1.6rem, 5vw, 2.4rem);
  font-weight: 900;
  letter-spacing: 0.04em;
  color: #ffd782;
`;

const Lead = styled.p`
  margin: 0 0 30px;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.9;
`;

const SectionTitle = styled.h2`
  margin: 28px 0 10px;
  font-size: 1.05rem;
  color: #ffffff;
`;

const Text = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.9;
`;

const CreditLink = styled.a`
  color: #ffd782;
  text-decoration: underline;
  text-underline-offset: 3px;
  word-break: break-word;

  &:hover {
    color: #ffffff;
  }
`;

function AssetCredits() {
  return (
    <PageWrapper>
      <Card>
        <Title>素材と権利表記</Title>
        <Lead>
          Muboで利用している一部素材やフォントに関する表記です。
        </Lead>

        <SectionTitle>診断画像の絵文字素材</SectionTitle>
        <Text>
          診断画像の一部絵文字素材には{" "}
          <CreditLink href="https://github.com/jdecked/twemoji" target="_blank" rel="noreferrer">
            Twemoji / jdecked
          </CreditLink>
          （CC BY 4.0）を利用しています。
        </Text>

        <SectionTitle>診断画像の文字表示</SectionTitle>
        <Text>
          診断画像の文字表示には、Noto Sans JP / Noto Sans CJK JP を利用する場合があります。
        </Text>
      </Card>
    </PageWrapper>
  );
}

export default AssetCredits;
